module.exports = "/fonts/halona-logotype-d-5dd136b1b6f28dc1c35d4b2ac6f52da9.svg";